import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useAuthStore } from "../state/authStore";
export default function RequireAuth({ children }) {
    const bootstrapped = useAuthStore((s) => s.bootstrapped);
    const user = useAuthStore((s) => s.user);
    if (!bootstrapped)
        return null;
    if (!user) {
        if (window.location.pathname !== "/login")
            window.location.assign("/login");
        return null;
    }
    return _jsx(_Fragment, { children: children });
}
